import { OrganismeOptionalConverter } from './converters/organisme.converter';
import { Domaine } from './domaine.model';
import { Organisme } from './organisme.model';
import { Profil } from './profil.model';
import { Service } from './service.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class UtilisateurProfil {
    static jsonMap = {
        id: { key: 'id', optional: true },
        domaine: { key: 'idDomaine', converter: new (DataIdConverterFactory.build(Domaine, 'domaines'))(), optional: true },
        organisme: { key: 'idOrganisme', converter: new OrganismeOptionalConverter(), optional: true },
        service: { key: 'idService', converter: new (DataIdConverterFactory.build(Service, 'services'))(), optional: true },
        profil: { key: 'idProfil', converter: new (DataIdConverterFactory.build(Profil, 'profils'))(), optional: true }
    };

    public id: number;
    public domaine: Domaine;
    public organisme: Organisme;
    public service: Service;
    public profil: Profil;
}
